export const fetchEventList = async () => {
  const res = await fetch("https://petros-global.com/ems/backend/events/fetch.php", {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
  });

  const json = await res.json();

  return json;
};

export const createEventItem = async (newEvent) => {
  const res = await fetch("https://petros-global.com/ems/backend/events/create.php", {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
    method: "POST",
    body: JSON.stringify({
      variables: newEvent
    })
  });

  const json = await res.json();

  return json;
};

export const updateEvent = async (updatedEvent) => {
  const res = await fetch("https://petros-global.com/ems/backend/events/update.php", {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
    method: "POST",
    body: JSON.stringify({
      variables: updatedEvent
    })
  });

  return res;
}

export const fetchEventByRef = async (refLink) => {
  const res = await fetch("https://petros-global.com/ems/backend/events/fetchByRef.php?refLink=" + refLink, {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
  });

  const json = await res.json();

  return json;
}

export const uploadAttendees = (attendeesList, eventId) => {
  return fetch("https://petros-global.com/ems/backend/upload/upload_attendees.php", {
    cache: "no-store",
    headers: {
      "Authorization": "Ok"
    },
    method: "POST",
    body: JSON.stringify({
      variables: {
        attendees: attendeesList,
        eventId,
      }
    }),
  });
}